import React, { useEffect, useState } from "react";
import { Country, State, City } from "../../Data/CountryStateCity";
// import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import {
  ServiceType,
  Locality,
  SubLocality,
  PropertyArea,
  PropertyPrice,
  PropertyType,
  ResidentialPropertyCategory,
  CommercialPropertyCategory,
  FollowUp,
  Ccode,
  Blank,
} from "../../Data/Data";
import {
  CustomSelectFiled,
  CustomInputField,
  CustomFormLabel,
  CustomFormGroup,
  CustomTextareaField,
  CustomMobileFiled,
  CustomMultiSelectFiled,
} from "../../Components/Common";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import PropTypes from "prop-types";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  getAllCandidateSourceList,
  getAllCandidatePositionList,
  getAllCandidateStatusList,
  setCandidate,
  getCandidate,
} from "./ApiCalls";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

//
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const EditCandidate = () => {
  const navigate = useNavigate();
  const lastlocation = useParams();

  const candidateId = useParams();
  const [candidateDetails, setCandidateDetails] = useState("");
  const [name, setName] = useState("");

  const [follow_up, setFollowUp] = useState();
  const [leadStatus, setCandidateStaus] = useState();
  const [ptype, setPtype] = useState();

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [sourcelist, setAllSourceList] = React.useState([]);
  const [positionlist, setAllPositionList] = React.useState([]);
  const [statuslist, setAllStatusList] = React.useState([]);

  // tabs
  const [myTabs, setMyTabs] = React.useState("default");
  const handleTabChange = (event, newValue) => {
    setCandidateDetails("");
    console.log(candidateDetails);
    setMyTabs(newValue);
    // console.log(candidateDetails)
  };

  useEffect(() => {
    getAllCandidateSourceList()
      .then((response) => {
        console.log(response);
        if (response.data === "No Data Found") {
          setAllSourceList(response.data.data);
        } else {
          setAllSourceList(
            response.data.map((sourcelist) => ({
              value: sourcelist.candidate_source,
              label: sourcelist.candidate_source,
            }))
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCandidatePositionList()
      .then((response) => {
        console.log(response);
        if (response.data === "No Data Found") {
          setAllPositionList(response.data.data);
        } else {
          setAllPositionList(
            response.data.map((positionlist) => ({
              value: positionlist.candidate_post,
              label: positionlist.candidate_post,
            }))
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCandidateStatusList()
      .then((response) => {
        console.log(response);
        if (response.data === "No Data Found") {
          setAllStatusList(response.data.data);
        } else {
          setAllStatusList(
            response.data.map((statuslist) => ({
              value: statuslist.candidate_status,
              label: statuslist.candidate_status,
            }))
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    leadDetailData();
  }, [candidateId, selectedCountry, selectedState, selectedCity]);

  const notify = (msg) =>
    toast(msg, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  //
  function filterCity(selectedState) {
    let myCity = City.filter(
      (City) => selectedState.countryCode.indexOf(City.countryCode) !== -1
    );
    return myCity.filter(
      (citynew) => selectedState.isoCode.indexOf(citynew.stateCode) !== -1
    );
  }

  const leadDetailData = () => {
    //
    let countries = Country;
    let states =
      selectedCountry !== null
        ? State.filter(
            (State) => selectedCountry.isoCode.indexOf(State.countryCode) !== -1
          )
        : [];
    let cities =
      selectedState !== null && selectedState.length !== 0
        ? filterCity(selectedState)
        : [];
    getCandidate(candidateId)
      .then((response) => {
        console.log(response.data);
        setCandidateDetails(response.data[0]);
        setFollowUp(response.data[0].followup);
        if (!selectedCountry && response.data[0].country) {
          countries.map((cname, key) =>
            cname.name === response.data[0].country
              ? setSelectedCountry(Country[key])
              : null
          );
        }
        if (!selectedState && response.data[0].state) {
          states.map((sname, key) =>
            sname.name === response.data[0].state
              ? setSelectedState(
                  State.filter(
                    (State) =>
                      selectedCountry.isoCode.indexOf(State.countryCode) !== -1
                  )[key]
                )
              : null
          );
        }
        if (!selectedCity && response.data[0].city) {
          cities.map((cityname, key) =>
            cityname.name === response.data[0].city
              ? setSelectedCity(filterCity(selectedState)[key])
              : null
          );
        }
        //
        setPtype(response.data[0].ptype);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleEditCandidate = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (parseInt(data.get("lmobile")) === 0) {
      notify("Please fill out required fields.");
    } else {
      setCandidate(data, candidateId)
        .then((response) => {
          notify("Candidate is Updated.");
          console.log(data.get("cname"));
          setTimeout(() => {
            navigate("/all-candidate");
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleChangeStatus = (event) => {
    if (event !== null) {
      setCandidateStaus(event.value);
    }
  };
  console.log(sourcelist);
  return (
    <>
     
      <Breadcrumb
        PageName="Edit Candidate"
        BackButton={[
          true,
          "Back",
          lastlocation.lastlocation === "assigncandidates"
          ? "/assigncandidates"
          : lastlocation.lastlocation === "nonassigncandidate"
          ? "/nonassigncandidate"
          : lastlocation.lastlocation
          ? "/candidate-by-status/"
          // ? "/candidate-by-status/" + lastlocation.lastlocation
          : "/all-candidate/",
          <ArrowBackIosOutlinedIcon />,
        ]}
      />
      <Box
        component="form"
        autoComplete="off"
        onSubmit={handleEditCandidate}
        method="post"
      >
        <Box className="custom-card">
          <Typography variant="h4" className="custom-card-head">
            Candidate Details :-
          </Typography>
          <Box p={2}>
            <Grid container spacing={2} mb={2}>
              {/* <CustomFormGroup
                formlabel="Candidate Name"
                star="*"
                FormField={
                  <CustomInputField
                    type="text"
                    name="lname"
                    placeholder="Enter Candidate Name"
                    required={true}
                    defaultVal={candidateDetails.cname}
                  />
                }
              /> */}
              <CustomFormGroup
                formlabel="Candidate Name"
                star="*"
                FormField={
                  <CustomInputField
                    type="text"
                    name="cname"
                    placeholder="Enter Candidate Name"
                    required={true}
                    defaultVal={candidateDetails.c_name}
                  />
                }
              />
              <CustomMobileFiled
                formlabel="Mobile No."
                star="*"
                type="text"
                placeholder="Mobile No."
                Inputname={["lccode", "lmobile"]}
                options={Ccode}
                defaultVal={
                  candidateDetails.c_ccode + " " + candidateDetails.c_mob
                }
                disabled={true}
                // disabled={Cookies.get('role') === 'Master' || Cookies.get('role') === 'Admin' ? false : true}
              />
              <CustomMobileFiled
                formlabel="Alt Mobile No."
                star="*"
                type="text"
                placeholder="Mobile No."
                Inputname={["alt_lccode", "alt_lmobile"]}
                options={Ccode}
                defaultVal={
                  candidateDetails.c_alt_ccode +
                  " " +
                  candidateDetails.c_alt_mob
                }
                disabled={false}
                // disabled={Cookies.get('role') === 'Master' || Cookies.get('role') === 'Admin' ? false : true}
              />
              <CustomFormGroup
                formlabel="Email Id."
                star="*"
                FormField={
                  <CustomInputField
                    type="email"
                    name="cemail"
                    placeholder="Enter Email Id."
                    required={true}
                    defaultVal={candidateDetails.c_email}
                  />
                }
              />
              <CustomFormGroup
                formlabel="Candidate Source"
                star="*"
                FormField={
                  <CustomSelectFiled
                    name="csource"
                    required={true}
                    defaultVal={candidateDetails.c_source}
                    options={sourcelist}
                    inputrole="Edit Candidate Source"
                  />
                }
              />
              <CustomFormGroup
                formlabel="Candidate  Position"
                star="*"
                FormField={
                  <CustomSelectFiled
                    name="cposition"
                    required={true}
                    defaultVal={candidateDetails.c_position}
                    options={positionlist}
                    inputrole="Edit Candidate Position"
                  />
                }
              />
              <CustomFormGroup
                formlabel="Candidate Status"
                star="*"
                FormField={
                  <CustomSelectFiled
                    name="cstatus"
                    required={true}
                    defaultVal={candidateDetails.c_status}
                    options={statuslist}
                    inputrole="Edit Candidate Status"
                  />
                }
              />
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} md={2} className="custom-from-group">
                <Typography variant="h6" className="custom-form-label">
                  Country
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Select
                  name="country"
                  options={Country}
                  defaultVal="India"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedCountry}
                  onChange={(item) => {
                    setSelectedCountry(item);
                    setSelectedState([]);
                    setSelectedCity([]);
                  }}
                />
              </Grid>
              <Grid item xs={6} md={2} className="custom-from-group">
                <Typography variant="h6" className="custom-form-label">
                  State
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Select
                  name="state"
                  options={
                    selectedCountry !== null
                      ? State.filter(
                          (State) =>
                            selectedCountry.isoCode.indexOf(
                              State.countryCode
                            ) !== -1
                        )
                      : []
                  }
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedState}
                  onChange={(item) => {
                    setSelectedState(item);
                    setSelectedCity([]);
                  }}
                />
              </Grid>
              <Grid item xs={6} md={2} className="custom-from-group">
                <Typography variant="h6" className="custom-form-label">
                  City
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Select
                  name="city"
                  options={
                    selectedState !== null && selectedState.length !== 0
                      ? filterCity(selectedState)
                      : []
                  }
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={selectedCity}
                  onChange={(item) => {
                    setSelectedCity(item);
                  }}
                />
              </Grid>

              <CustomFormGroup
                formlabel="Locality"
                FormField={
                  <CustomInputField
                    type="text"
                    name="locality"
                    placeholder="Enter Locality"
                    defaultVal={candidateDetails.locality}
                  />
                }
              />
            </Grid>

            <Grid container spacing={2} my={1}>
              <Grid item xs={6} md={2}></Grid>
              <Grid item xs={6} md={10}>
                <Button variant="contained" type="submit">
                  Save Candidate
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default EditCandidate;
